import { Chip } from '@mi-front/ui';
import ErrorIcon from '@mui/icons-material/Error';
import { FormattedMessage } from 'react-intl';

export function NoAudioIndicator() {
  return (
    <Chip type="danger">
      <ErrorIcon sx={{ fontSize: 'inherit', verticalAlign: 'middle' }} />{' '}
      <span className="ml-1">
        <FormattedMessage id="audit.schedulesListScreen.noAudio" defaultMessage="Sin archivo">
          {(text) => <span className="ml-1">{text}</span>}
        </FormattedMessage>
      </span>
    </Chip>
  );
}
